import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import TemplateEOCList from './template-eoc-list';
import TemplateEOCAdd from './template-eoc-add';

import * as ProjectActionType from 'Projects/constants';

import './template.css';

class TemplateEOC extends Component {

    static propTypes = {
      projectId: PropTypes.string,
      dispatch: PropTypes.func,
      DefaultTemplateList: PropTypes.array,
      isOpen: PropTypes.bool,
      getDefaultTemplate: PropTypes.func,
      customTemplateList: PropTypes.object,
      BuilderName: PropTypes.string,
      ProjectListCopy: PropTypes.array
    }

    constructor(props) {
      super(props);
      this.state = {
        isOpen: false,
        checked: false,
        openAddCustomTemplate: true,
        items: this.props.DefaultTemplateList,
        builderName: this.props.BuilderName
      };
    }

    componentDidMount() {
      this.getDefaultTemplate();
      this.onGetBuilderName();
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.DefaultTemplateList !== nextProps.DefaultTemplateList) {
        this.setState({ items: nextProps.DefaultTemplateList});
        // this.getDefaultTemplate();
      }

      if (this.props.BuilderName !== nextProps.BuilderName) {
        this.setState({ builderName: nextProps.BuilderName});
      }
    }

    getDefaultTemplate() {
      this.props.getDefaultTemplate();
    }

    onCloseCustomTempSectionModal = () => {
      this.setState({
        isOpen: false
      });
    }

    onGetBuilderName = () => {
      this.props.dispatch({
        type: ProjectActionType.GET_BUILDER_NAME_ASYNC,
        params: null
      });
    }

    selectCustomTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.SELECT_CUSTOM_TEMPLATE_ASYNC,
        params: {
          projectId: params.projectId,
          templateId: params.templateId
        }, callback
      });
    }

    selectDefaultTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.SELECT_CUSTOM_TEMPLATE_ASYNC,
        params: {
          projectId: params.projectId,
          templateId: params.templateId
        },
        callback
      });
    }

    onCreateCustomTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.CREATE_NEW_PROJECT_EOC_TEMPLATE_ASYNC,
        params: {
          projectId: this.props.projectId,
          data: params.data
        },
        callback
      });
    }

    onEditCustomTemplate = (params, callback) => {
      let submittedSections = params.data.sections.map(section => {
        return {
          title: section.title,
          type: section.type,
          value:section.value?1:0,
          items: section.items&&section.items.filter(item => item.content !== null && item.content.length > 0).map(item => {
            return {
              content: item.content
            };
          })
        };
      });

      this.props.dispatch({
        type: ProjectActionType.EDIT_CUSTOM_TEMPLATE_ASYNC,
        params: {
          templateId: params.templateId,
          projectId: this.props.projectId,
          data: {
            name: params.data.name,
            disclaimerText: params.data.disclaimer,
            sections: submittedSections,
            EofStatus: params.data.EofStatus
          }
        }, callback
      });
    }

    getCustomTemplateDetail = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_CUSTOM_TEMPLATE_DETAIL_ASYNC,
        params: {
          projectId: params.projectId,
          templateId: params.templateId
        },
        callback
      });
    }

    onDuplicateEOCTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.DUPLICATE_EOC_TEMPLATE_ASYNC,
        params: {
          projectId: params.projectId,
          templateId: params.templateId
        },
        callback
      });
    }

    onCopyEOCTemplate = (params, callback) => {
      this.props.dispatch({
        type: ProjectActionType.COPY_EOC_TEMPLATE_ASYNC,
        params: {
          sourceProjectId: params.sourceProjectId,
          targetProjectId: params.targetProjectId,
          templateId: params.templateId
        },
        callback
      });
    }

    onFetchProject = (params) => {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_COPY_EOC_TEMPLATE_LIST_ASYNC,
        params: {
          excludeProjectId: params.projectId
        }
      });
    };
    renderCustomTemplateList() {
      return (
        <TemplateEOCList
          onEditCustomTemplate={this.onEditCustomTemplate}
          customTemplateList={this.props.customTemplateList}
          getCustomTemplateDetail={this.getCustomTemplateDetail}
          selectCustomTemplate= {this.selectCustomTemplate}
          selectDefaultTemplate={this.selectDefaultTemplate}
          projectId={this.props.projectId}
          DefaultTemplateList={this.props.DefaultTemplateList}
          getDefaultTemplate={this.props.getDefaultTemplate}
          onDuplicateEOCTemplate={this.onDuplicateEOCTemplate}
          onCopyEOCTemplate={this.onCopyEOCTemplate}
          onFetchProject={this.onFetchProject}
          ProjectListCopy={this.props.ProjectListCopy}
        />
      );
    }

    render() {
      // const {items} = this.state;
      const {isOpen} = this.state;
      return (
        <React.Fragment>
          <div className=' margin-bottom-30 container-fluid'>

            {this.renderCustomTemplateList()}

            <button
              style={{marginTop: 15}}
              className='btn btn-primary btn-siteone-default'
              onClick={() => this.setState({ isOpen: true})}
            ><span className='fa fa-plus icon' /> Add</button>
          </div>

          {
            isOpen && <TemplateEOCAdd
              isOpen={isOpen}
              builderName={this.state.builderName}
              onCreateCustomTemplate={this.onCreateCustomTemplate}
              onClose={this.onCloseCustomTempSectionModal}
              getDefaultTemplate={this.props.getDefaultTemplate}/>
          }
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    ProjectStore: state.ProjectStore,
    customTemplateList: state.ProjectStore.customTemplateList,
    BuilderName: state.ProjectStore.BuilderName,
    ProjectListCopy: state.ProjectStore.ProjectListCopy
  };
};

export default connect(mapStateToProps)(TemplateEOC);



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-eoc.js